var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: "VIEW_PORTFOLIO",
          expression: "'VIEW_PORTFOLIO'",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c("portfolio-widget-row", { attrs: { fetch: true } }),
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "vulnerabilitiesToolbar" },
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.vulnerabilityCreateVulnerabilityModal",
                  modifiers: { vulnerabilityCreateVulnerabilityModal: true },
                },
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: _vm.PERMISSIONS.VULNERABILITY_MANAGEMENT,
                  expression: "PERMISSIONS.VULNERABILITY_MANAGEMENT",
                },
              ],
              attrs: { size: "md", variant: "outline-primary" },
            },
            [
              _c("span", { staticClass: "fa fa-plus" }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.create_vulnerability")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": _vm.onLoadSuccess },
      }),
      _c("vulnerability-create-vulnerability-modal", {
        on: { refreshTable: _vm.refreshTable },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }